import { render } from "./RolesEditView.vue?vue&type=template&id=1bd508c9"
import script from "./RolesEditView.vue?vue&type=script&lang=js"
export * from "./RolesEditView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__